<template>
  <el-dialog
    ref="modal"
    class="success-promo-modal"
    :visible="show"
    @update:visible="$emit('update:show', false)"
  >
    <div class="success-promo">
      <h1>🎉 Hooray 🎉</h1>
      <h2>Your signature successfully created and copied!</h2>
      <br>
      <img :src="`${publicPath}logo.png`" width="210" height="50">
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SuccessPromo',

  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  created () {
    this.$root.$on('social_shares_open', (payload) => {
      this.gaEventClick(`social ${payload}`)
    })
  }
}
</script>

<style lang="scss">
.success-promo {
  text-align: center;
}
.success-promo-modal {
  .el-dialog {
    &__header {
      padding-bottom: 0;
    }
    h1 {
      margin-top: 0;
    }
  }
}
</style>
